module.exports = __webpack_public_path__ + "static/media/Yeqing Deng.d59fa493.png";